export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-the-account-custom-statement': 'Imprimir estado de cuenta personalizado',
    'custom-statements': 'Estados personalizados',
    'balanced-accounts-only': 'Solo cuentas con saldo',
    'show-all-columns': 'Mostrar todas las columans',
    refresh: 'Actualizar',

    'total-debit-balance': 'Total saldo deudor:',
    'total-credit-balance': 'Total saldo acreedor:',
    'total-difference-balance': 'Diferencia de total:',
    headers: {
        'account-no': 'Id',
        'account-name': 'Nombre de cuenta',
        'parent-account': 'Cuenta principal',
        'debit-balance': 'Saldo deudor',
        'credit-balance': 'Saldo acreedor',
        'last-debit-amount': 'Última actividad de débito',
        'last-debit-date': 'Fecha de la última actividad de débito',
        'last-credit-amount': 'Última actividad de crédito',
        'last-credit-date': 'Fecha de la última actividad de crédito',
    },

    'sum-debit-credit-result-headers': {
        'sum-debits': 'Débito total',
        'sum-credits': 'Crédito total',
        'debit-balance': 'Saldo deudor',
        'credit-balance': 'Saldo acreedor',
    }
}